import React, { Component } from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Card, Dropdown, Table, Button, Icon } from 'semantic-ui-react';
import View from './view';
import Add from './add';
import AddIcon from '@material-ui/icons/Add';
import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class Bankdetails extends Component {

  state = {
    data: [],
    openAdd: false,
    executive: [], menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('edit-bank-details', this.props.menus);
    if (menuPermission.view) {
      this.getbankDetails();
    }
    this.setState({ menuPermission })
  }

  getbankDetails() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data = { 'userId': userId };
    context.setState({
      load: true,
      message: 'Getting Bank Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/get.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        context.getAllExecutives(data);
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  getAllExecutives(val) {
    let context = this;
    let data = {};
    context.setState({
      load: true,
      message: 'Getting Executive Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'menucontrol/get.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          val = JSON.parse(val)
          for (var i = 0; i < val.length; i++) {
            let s = 1;
            val[i].sino = s + i;
          }
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            executive: data,
            data: val,
            load: false
          });
        } catch (e) {
          console.log(e);
          context.setState({
            load: false
          });
        }
      },
      error: function (e)
      {
        context.setState({
          load: false
        });
      }
    });
  }

  updateData(data) {
    this.setState({
      data: data
    })
  }

  add() {
    this.setState({
      openAdd: true
    })
  }

  closeAdd() {
    this.setState({
      openAdd: false
    })
  }

  updateDatass() {
    this.setState({
      openAdd: false
    })
    this.getbankDetails();
  }

  render() {
    let view, add, loading;
    let { data, openAdd, executive, load, message } = this.state;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
        <Title title={'Edit Bank Details'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <Grid style={{display: this.state.bankviewcontrol}}>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Card fluid style={{padding: '1%'}}>
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <View data={data} updateData={this.updateData.bind(this)}
                            menuPermission={this.state.menuPermission}
                              bankeditcontrol={this.state.bankeditcontrol} executive={executive}/>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        {
                          this.state.menuPermission.add ?
                          <Button icon labelPosition='left' primary
                            onClick={this.add.bind(this)}>
                            <Icon name='plus' />
                            Add Bank Detail
                          </Button>:''
                        }
                        
                      </Grid.Column>
                    </Grid>
                  </Card>
                </Grid.Column>
              </Grid>
              { openAdd ?
                (
                  <div>
                    <Add open={openAdd} updateDatas={this.updateDatass.bind(this)}
                         closeAdd={this.closeAdd.bind(this)} />
                  </div>
                ) :
                (
                  <div></div>
                )
              }
              {loading}
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Bankdetails;
